/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignupInitializationRequestWithAuthenticationDetails
 */
export interface SignupInitializationRequestWithAuthenticationDetails {
    /**
     * An path where to redirect the user when the signup is complete
     * @type {string}
     * @memberof SignupInitializationRequestWithAuthenticationDetails
     */
    redirectPath?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupInitializationRequestWithAuthenticationDetails
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SignupInitializationRequestWithAuthenticationDetails
     */
    password: string;
}

/**
 * Check if a given object implements the SignupInitializationRequestWithAuthenticationDetails interface.
 */
export function instanceOfSignupInitializationRequestWithAuthenticationDetails(value: object): value is SignupInitializationRequestWithAuthenticationDetails {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SignupInitializationRequestWithAuthenticationDetailsFromJSON(json: any): SignupInitializationRequestWithAuthenticationDetails {
    return SignupInitializationRequestWithAuthenticationDetailsFromJSONTyped(json, false);
}

export function SignupInitializationRequestWithAuthenticationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupInitializationRequestWithAuthenticationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectPath': json['redirectPath'] == null ? undefined : json['redirectPath'],
        'email': json['email'],
        'password': json['password'],
    };
}

export function SignupInitializationRequestWithAuthenticationDetailsToJSON(value?: SignupInitializationRequestWithAuthenticationDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'redirectPath': value['redirectPath'],
        'email': value['email'],
        'password': value['password'],
    };
}

